import Link from 'next/link';

import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const StyContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._16};
`;

export const StySeparator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._10};
`;

export const StyLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.neutral[700]};
`;

export const StyOthersSignIn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
`;

export const StyOpenAccount = styled.div`
  padding-top: ${SPACING._16};
`;

export const StyCreateAccount = styled(Link)`
  width: fit-content;
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  gap: ${SPACING._4};

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const StyBackLogin = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  gap: ${SPACING._4};
  margin-top: ${SPACING._16};

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const AppAuthDataInfoContainer = styled.div`
  display: none;
  flex-direction: column;
  width: 100%;
  gap: ${SPACING._16};
  padding: 5%;
  min-width: 270px;
  max-width: 750px;
  /* height: 100%; */
  justify-content: center;
  align-items: center;
  font-weight: bold;
`;